<template>
    <div class="w-full py-10 px-10 lg:px-20 xl:px-32" id="footer">
        <h1 class="text-2xl text-white md:text-4xl font-bold pb-8 uppercase block">
            {{ tr('footer.title') }}
        </h1>
        <div class="flex flex-row flex-wrap items-end justify-start w-full">
            <div class="pr-16">
                <p class="text-white">
                    PaRELI s.r.o
                </p>
                <p class="text-white">
                    Vlárska 50/A
                </p>
                <p class="text-white">
                    831 01 Bratislava
                </p>
            </div>

            <div class="pt-10 lg:pt-0 pr-16">
                <p class="text-white">
                    {{ tr('footer.id') }}: 47 205 555
                </p>
                <p class="text-white">
                    {{ tr('footer.taxId') }}: SK2023803188
                </p>
                <p class="text-white">
                    IBAN: SK77 1100 0000 0029 2089 6486
                </p>
            </div>

            <div class="pt-10 lg:pt-0">
                <p v-for="(text, id) in tr('footer.registration')"
                   class="text-white"
                   :key="id"
                >
                    {{ text }}
                </p>
            </div>

            <div class="flex-grow"></div>

            <div class="flex-grow md:flex-initial pt-10 qhd:pt-0 mx-auto md:mx-0 text-xs md:text-base">
                <p class="text-white">
                    ©
                    <a class="font-bold underline" href="https://www.revolware.com" target="_blank">
                        Revolware.com
                    </a>
                    since 2020. All rights reserved.
                </p>
            </div>
        </div>

    </div>
</template>

<script>
import {Translatable} from '@/data/translations';

export default {
    name: 'Footer',
    mixins: [Translatable],
};
</script>

<style scoped>
#footer {
    background: linear-gradient(to top, rgb(50, 50, 50), rgb(82, 80, 80));
}
</style>
